import script from "./Information.vue?vue&type=script&setup=true&lang=js"
export * from "./Information.vue?vue&type=script&setup=true&lang=js"

import "./Information.vue?vue&type=style&index=0&id=4773fedb&lang=scss&scoped=true"

import exportComponent from "/Users/ruslan/Desktop/birch/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4773fedb"]])

export default __exports__